import { ProfileTopperProps } from "design-system/components/toppers/profile-topper/profile-topper";
import { WKProfileTopperEntry } from "frontend/contentful/schema/toppers";
import { createContentfulProps } from "frontend/contentful/lib/create-contentful-props";
import { getPersonProps } from "../utils/get-person.props";

export const createWKProfileTopperProps = createContentfulProps<
  WKProfileTopperEntry,
  ProfileTopperProps
>(({ entry }) => {
  const props: ProfileTopperProps = {};

  const personProps = getPersonProps(entry.fields.person);

  props.theme = entry.fields.theme;

  let mediaAsset = undefined;

  if (personProps) {
    props.titles = personProps.titles;
    props.name = personProps.personName;

    if (!mediaAsset) mediaAsset = personProps.portrait;

    if (mediaAsset) {
      props.portrait = {
        ...mediaAsset,
        width: "245px",
        height: "259px",
      };
    }

    if (personProps.link) {
      props.bioLink = {
        href: personProps.link,
        children: "Read full bio",
      };
    }

    if (personProps.bio) {
      props.bio = personProps.bio;
    }
  }

  return props;
});
